import { TABLE_COLUMNS, processResponse } from "components/LM/Voice/Search/VoiceSearch";
import AdvancedTable from "components/LM/common/AdvancedTable";
import React from "react";
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";

function VoiceMergeSuggestion(props) {
	const { currentVoice, suggestedVoices, onClose } = props;
	const history = useHistory();

	const [selectedVoices, setSelectedVoices] = React.useState([]);

	const handleChecked = (checkedItems) => {
		const selectedVoices = checkedItems.map(id => suggestedVoices.find(voice => voice.id === id));
		setSelectedVoices(selectedVoices);
	}

	const onSubmit = () => {
		history.push({
			pathname: "/voices/merge",
			search: `?ids=${[currentVoice, ...selectedVoices].map(voice => voice.id).join(",")}`,
			state: {
				voices: [currentVoice, ...selectedVoices]
			}
		});
	}


	const warningMessage = () => {
		if (selectedVoices.length < 1) return "You need more than 1 voice to process with the merge";
		if (selectedVoices.length > 4) return `You cannot merge more than 5 voices at once (including the current voice: ${currentVoice.name})`;
		return null;
	}

	const isProcessable = selectedVoices.length >= 1 && selectedVoices.length <= 4;

	return (
		<>
			<AdvancedTable
				columns={TABLE_COLUMNS}
				hidePagination={true}
				selectable={true}
				onSelectRows={checkedItems => handleChecked(checkedItems)}
				selectedItems={selectedVoices.map(voice => voice.id)}
				data={processResponse({ total: suggestedVoices.length, voices: suggestedVoices })} />
			<Button onClick={onSubmit} disabled={!isProcessable} className="mt-2">
				Start process
			</Button>
			<span className="ml-1 text-warning align-middle">{warningMessage()}</span>
			<Button
				variant="outline-dark"
				onClick={onClose}
				className="mt-2 float-right">
				Cancel
			</Button>
		</>
	);
}

export default VoiceMergeSuggestion;
